import React, {useEffect, useMemo, useState, useCallback, forwardRef, useImperativeHandle} from "../../../../../__snowpack__/pkg/react.js";
import {
  Space,
  Cascader,
  Button,
  Col,
  Collapse,
  Form,
  Input,
  Popover,
  Row,
  Select,
  Tag,
  message,
  Typography,
  Spin,
  DatePicker
} from "../../../../../__snowpack__/pkg/antd.js";
import moment from "../../../../../__snowpack__/pkg/moment-timezone.js";
import {SelectInput3} from "../../../../components/SelectInput3.js";
import {TextQuantitative} from "../../../../components/TextQuantitative.js";
import {SelectInputQuantitative} from "../../../../components/SelectInputQuantitative.js";
import {axios} from "../../../../lib/axios.js";
import {request} from "../../../../utils/request/index.js";
import {useRequest} from "../../../../../__snowpack__/pkg/ahooks.js";
import {cascaderFilter, cascaderRender} from "../../../../components/BaseCascader/filterRenderMethod.js";
import {ExclamationCircleOutlined} from "../../../../../__snowpack__/pkg/@ant-design/icons.js";
import {SyncButton} from "../../../../components/syncButton.js";
import {InputLimit} from "../../../../components/InputLimit.js";
import {IconDown, IconDropdown} from "../../../../../__snowpack__/pkg/@genieui-react/icon.js";
import {useCategories} from "../../../../entities/product-shopee/useCategories.js";
import {TableStoreLogo} from "../../../../components/TableStoreLogo.js";
import {TableStore} from "../../../../components/TableStore.js";
import UploadCertification from "./components/UploadCertification.js";
import {debounce, isArray} from "../../../../../__snowpack__/pkg/lodash.js";
import {RecommendedCheck} from "./components/RecommendedCheck.js";
import {
  useShopCountryModel,
  useCatrgoryInfoModel,
  useCategoryRuleChannelModel,
  useExternalShopIdModel,
  useCategoryAttributesModel,
  useExternalWareIdModel,
  useBrandsModel,
  useVariationOptionsModel,
  PRODUCTNAME_MIN_NUMBER,
  PRODUCTNAME_MAX_NUMBER
} from "../../store.js";
import styled from "../../../../../__snowpack__/pkg/styled-components.js";
import {useIntl} from "../../../../../__snowpack__/pkg/react-intl.js";
import viewMoreSvg from "../../assets/view-more.svg";
import checked from "../../assets/checked.png";
import unchecked from "../../assets/unchecked.png";
const {Panel} = Collapse;
const {Option} = Select;
const CascaderWrapper = (props) => {
  const {formatMessage} = useIntl();
  const {categoriesList, fetchData: fetchCategoriesList} = useCategories();
  useEffect(() => {
    if (props.countryCode) {
      fetchCategoriesList("TIKTOK_ID", props.countryCode);
    }
  }, [props.countryCode]);
  return /* @__PURE__ */ React.createElement(Cascader, {
    id: props.id,
    value: props.value,
    expandTrigger: "hover",
    fieldNames: {
      label: "name",
      value: "id"
    },
    disabled: !props.countryCode,
    showSearch: {filter: cascaderFilter, render: cascaderRender},
    placeholder: formatMessage({id: "selectCategories"}),
    suffixIcon: /* @__PURE__ */ React.createElement(IconDropdown, {
      style: {height: 14, width: 14}
    }),
    options: categoriesList,
    onChange: (val) => {
      props.onChange && props.onChange(val);
    }
  });
};
export const getCategoryAttributeFormValue = (attributeId, attribute, categoryAttributes) => {
  const item = categoryAttributes.find((_) => _.attributeId === attributeId);
  if (item && item.type === "TEXT") {
    return attribute[0]?.value_name;
  }
  if (item && item.type === "TEXT_QUANTITATIVE") {
    return {
      value: attribute[0]?.value_name,
      unit: attribute[0]?.unit
    };
  }
  if (item && item.type === "SELECT_INPUT_QUANTITATIVE") {
    if (attribute[0]?.value_id === 0) {
      return attribute[0]?.value_name + attribute[0]?.unit;
    }
    return attribute[0]?.value_id;
  }
  if (item && item.type === "DATE") {
    return moment(Number(attribute[0]?.value_name) * 1e3);
  }
  if (item && ["SELECT", "SELECT_INPUT"].includes(item.type)) {
    const optionsId = item?.options?.map((item2) => item2.attributeValueId);
    if (!optionsId.includes(attribute[0]?.value_id)) {
      return attribute[0]?.value_name;
    }
    return attribute[0]?.value_id;
  }
  if (item && ["MULTI_SELECT", "MULTI_SELECT_INPUT"].includes(item.type)) {
    const optionsId = item?.options?.map((item2) => item2.attributeValueId);
    return attribute.map((_) => {
      if (!optionsId.includes(_.value_id)) {
        return _.value_name;
      }
      return _.value_id;
    });
  }
};
export const getCategoryAttributeValue = (attributeId, value, categoryAttributes, infoData) => {
  const item = categoryAttributes.find((_) => _.attributeId === attributeId);
  if (item && item.type === "TEXT") {
    const textValueArr = infoData?.attributes?.productAttributes ? infoData?.attributes?.productAttributes[`${attributeId}`] : [];
    const textValue = textValueArr && textValueArr.length > 0 ? textValueArr[0] : {};
    if (textValue && textValue?.value_id) {
      return [
        {
          value_id: textValue.value_id,
          value_name: value
        }
      ];
    }
    return [
      {
        value_name: value
      }
    ];
  }
  if (item && item.type === "TEXT_QUANTITATIVE") {
    const curValue = value;
    return [
      {
        value_name: curValue.value,
        unit: curValue.unit
      }
    ];
  }
  if (item && item.type === "SELECT_INPUT_QUANTITATIVE") {
    const options = item.options;
    const selected = options?.find((_) => {
      const curLabel = Object.keys(_)[0];
      const curValue = _[curLabel];
      return curValue === value;
    });
    return [
      {
        value_id: selected?.attributeValueId,
        value_name: selected?.name
      }
    ];
  }
  if (item && item.type === "DATE") {
    return [
      {
        value_name: moment.isMoment(value) ? value.format("X").valueOf() : "",
        unit: ""
      }
    ];
  }
  if (item && ["SELECT", "SELECT_INPUT"].includes(item.type)) {
    const options = item.options;
    const itemInfo = item;
    const selected = options.find((_) => {
      const curLabel = Object.keys(_)[0];
      const curValue = _[curLabel];
      return curValue === value;
    });
    if (selected) {
      return [
        {
          value_id: selected?.attributeValueId,
          value_name: selected?.name
        }
      ];
    } else {
      const infoDataAttr = infoData?.attributes?.productAttributes ? infoData?.attributes?.productAttributes[`${itemInfo.attributeId}`] : [];
      const isAttr = infoDataAttr?.find((attr) => {
        return attr?.value_name === value;
      });
      if (isAttr) {
        return {
          value_id: isAttr.value_id,
          value_name: isAttr.value_name
        };
      }
      return {
        value_name: value
      };
    }
  }
  if (item && ["MULTI_SELECT", "MULTI_SELECT_INPUT"].includes(item.type)) {
    const options = item.options;
    const itemInfo = item;
    const selectedList = value?.map((_) => {
      const option = options.find((item2) => {
        const curLabel = Object.keys(item2)[0];
        const curValue = item2[curLabel];
        return _ === curValue;
      });
      if (option) {
        return option;
      } else {
        const infoDataAttr = infoData?.attributes?.productAttributes ? infoData?.attributes?.productAttributes[`${itemInfo.attributeId}`] : [];
        const isAttr = infoDataAttr?.find((attr) => {
          return attr?.value_name === _;
        });
        if (isAttr) {
          return {
            attributeValueId: isAttr?.value_id,
            name: isAttr?.value_name
          };
        }
        return {
          name: _
        };
      }
    }) || [];
    return selectedList.map((selected) => {
      if (!selected?.attributeValueId) {
        return {
          value_name: selected?.name
        };
      }
      return {
        value_id: selected?.attributeValueId,
        value_name: selected?.name
      };
    });
  }
};
export const WarrantyPeriodOption = [
  {value: 1, label: "4 weeks"},
  {value: 2, label: "2 months"},
  {value: 3, label: "3 months"},
  {value: 4, label: "4 months"},
  {value: 5, label: "5 months"},
  {value: 6, label: "6 months"},
  {value: 7, label: "7 months"},
  {value: 8, label: "8 months"},
  {value: 9, label: "9 months"},
  {value: 10, label: "10 months"},
  {value: 11, label: "11 months"},
  {value: 12, label: "12 months"},
  {value: 13, label: "2 years"},
  {value: 14, label: "3 years"},
  {value: 15, label: "1 week"},
  {value: 16, label: "2 weeks"},
  {value: 17, label: "18 months"},
  {value: 18, label: "4 years"},
  {value: 19, label: "5 years"},
  {value: 20, label: "10 years"},
  {value: 21, label: "lifetime warranty"}
];
export const formatUploadParams = (params) => {
  const isEmpty = Object.keys(params).every((files) => {
    if (!params[files]) {
      return true;
    }
    return params[files].length === 0;
  });
  if (isEmpty) {
    return [];
  }
  const imageType = ["image/jpeg", "image/png", "image/jpg"];
  const fileType = ["application/pdf"];
  const certifications = Object.keys(params).map((fileKey) => {
    const targetFile = params[fileKey];
    let file = {
      images: [],
      files: []
    };
    if (targetFile.length === 0) {
      return file;
    }
    targetFile.map((fileIndex) => {
      file.title = fileIndex.name;
      file.id = fileIndex.id;
      file.isMandatory = fileIndex.isMandatory;
      if (imageType.includes(fileIndex.type)) {
        const {fileId = "", fileUrl = "", imageVO = {}} = fileIndex.response;
        file.images.push({
          id: fileId,
          url: fileUrl,
          height: imageVO?.imgHeight,
          width: imageVO?.imgWidth
        });
      }
      if (fileType.includes(fileIndex?.type)) {
        const {fileId = "", fileUrl = "", fileVO = {}} = fileIndex.response;
        file.files.push({
          id: fileId,
          url: fileUrl,
          name: fileVO?.fileName,
          type: fileVO?.fileType
        });
      }
    });
    return file;
  });
  return certifications;
};
const BaseInfo = forwardRef((props, ref) => {
  const {handleStatus, infoData = void 0, isEdit = false, shopsData = []} = props;
  const [form] = Form.useForm();
  const [showMore, setShowMore] = useState(false);
  const {externalShopId, setExternalShopId} = useExternalShopIdModel();
  const {shopCountry, setShopCountry, setShopId, setCurrencyCode, shopId, currencyCode, setSupportMultiWarehouse} = useShopCountryModel();
  const {setCatrgoryInfo} = useCatrgoryInfoModel();
  const {fetchExternalWare, externalWareId} = useExternalWareIdModel();
  const [brandKeyword, setBrandKeyword] = useState("");
  const {fetchCategoryRuleChannel, resetCategoryRuleChannel, categoryRuleChannel} = useCategoryRuleChannelModel();
  const {brands, brandsLoading, updateBrandsLoading, fetchBrands, setBrands} = useBrandsModel();
  const {fetchCategoryAttributes, resetData, mandatoryCategoryAttributes, categoryAttributes, onlyEditAttributeData} = useCategoryAttributesModel();
  const {handleSetVariationOptions, defaultData} = useVariationOptionsModel();
  const [categoryRecommend, setCategoryRecommend] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const {formatMessage} = useIntl();
  const checkShopStatus = async (shopId2) => {
    let params = {
      channelId: "TIKTOK_ID",
      shopId: shopId2
    };
    await axios.post("/saas/shop/product/pre-check", params);
  };
  const getCategoryRecommend = async () => {
    let productName = form.getFieldValue("productName")?.trim();
    let shopIds = form.getFieldValue("shopIds");
    let categoryIds = form.getFieldValue("categoryIds");
    if (!productName || !shopIds.length || productName.length < 25) {
      return;
    }
    setCategoryLoading(true);
    const params = {
      channel: "TIKTOK_ID",
      shopId: shopIds.length ? shopIds[0] : "",
      productName,
      imageIds: [],
      description: "",
      countryCode: shopCountry
    };
    let data = await axios.post("/saas/shop/category-recommend", params);
    setCategoryLoading(false);
    let newCategoryRecommend = data.data?.filter((data2, index) => {
      let myData = data2.categories.map((data3) => {
        return data3.externalCategoryId;
      });
      if (!categoryIds && index == 0) {
        return false;
      }
      return myData?.join("-") !== (!!categoryIds ? categoryIds?.join("-") : categoryIds);
    });
    setCategoryRecommend(newCategoryRecommend || []);
    if (data?.data?.length) {
      let firstCategory = data.data[0]?.categories || [];
      let categoryIds2 = form.getFieldValue("categoryIds");
      if (!categoryIds2.length) {
        const resetCategoryList = firstCategory.map((data2) => {
          return data2.externalCategoryId;
        });
        categoryBeforeResetInfo(resetCategoryList);
        form.setFieldsValue({
          categoryIds: resetCategoryList
        });
      }
    }
  };
  useEffect(() => {
    if (!infoData) {
      return;
    }
    if (!shopsData.length) {
      return;
    }
    const shopId2 = infoData?.shopId;
    const newFieldsValue = {
      ...infoData,
      productDangerous: String(infoData.productDangerous),
      categoryIds: infoData?.externalFullCategoryId?.length ? infoData.externalFullCategoryId.split("-") : [],
      warrantyId: infoData?.warranty?.warrantyId,
      warrantyPolicy: infoData?.warranty?.warrantyPolicy
    };
    let shopCountry2 = "";
    let shopInfo = {};
    if (shopId2) {
      const shopIds = [shopId2];
      shopSelectChange(shopIds);
      shopInfo = shopsData.find((_) => _.id === shopId2) || {};
      const {countryCode, externalShopId: externalShopId2, currencyCode: currencyCode2} = shopInfo;
      shopCountry2 = countryCode;
      setShopCountry(countryCode);
      setExternalShopId(externalShopId2);
      setShopId(shopId2);
      setSupportMultiWarehouse(infoData?.shopMultiWarehouse);
      fetchExternalWare({channel: "TIKTOK_ID", shopId: shopId2 || ""});
      setCurrencyCode(currencyCode2);
    }
    if (infoData?.certifications && infoData?.certifications.length > 0) {
      const {certifications} = infoData;
      const certificationsList = certifications.map((item) => {
        const imagesList = (item?.images || []).map((image) => {
          return {
            name: image.url,
            url: image.url,
            uid: image.url,
            id: item.id,
            status: "success",
            type: "image/jpeg",
            response: {
              fileId: image.id,
              fileUrl: image.url,
              imageVO: {
                imgWidth: image.width,
                imgHeight: image.height
              }
            }
          };
        });
        const filesList = (item?.files || []).map((file) => {
          return {
            name: file.url,
            url: file.url,
            uid: file.url,
            id: item.id,
            status: "success",
            type: "application/pdf",
            response: {
              fileId: file.id,
              fileUrl: file.url,
              fileVO: {
                fileName: file.name,
                fileType: file.type
              }
            }
          };
        });
        return {
          id: item.id,
          [item.id]: [...filesList, ...imagesList]
        };
      });
      newFieldsValue.certifications = certificationsList[0];
    }
    const categoryId = [...newFieldsValue?.categoryIds].pop();
    setCatrgoryInfo(categoryId);
    let param = {
      countryCode: shopCountry2,
      channel: "TIKTOK_ID",
      categoryId
    };
    categoryId && fetchCategoryAttributes(param, true);
    categoryId && fetchCategoryRuleChannel(param);
    categoryId && fetchBrands({
      channel: "TIKTOK_ID",
      country: shopCountry2,
      prefix: "",
      categoryId: "",
      shopId: shopId2
    }, false);
    form.resetFields();
    form.setFieldsValue(newFieldsValue);
    setBrands([
      {
        label: infoData.brandId,
        value: infoData.brandName
      }
    ]);
  }, [infoData, shopsData]);
  useEffect(() => {
    const temp = {};
    if (onlyEditAttributeData && onlyEditAttributeData.length && props?.infoData?.attributes?.productAttributes) {
      onlyEditAttributeData.map((data) => {
        if (props?.infoData?.attributes?.productAttributes[`${data.attributeId}`]) {
          temp[`${data.attributeId}.productAttribute`] = getCategoryAttributeFormValue(data.attributeId, props?.infoData?.attributes?.productAttributes[`${data.attributeId}`], onlyEditAttributeData);
        }
      });
      form.setFieldsValue({...temp});
    }
  }, [onlyEditAttributeData]);
  useImperativeHandle(ref, () => ({
    submit: async () => {
      try {
        await form.validateFields();
      } catch (error) {
        throw {
          error,
          form
        };
      }
      const values = form.getFieldsValue();
      let certifications = [];
      if (values.certifications) {
        certifications = formatUploadParams(values.certifications);
      }
      const params = isEdit ? {shopId: values.shopIds[0]} : {shopIds: values.shopIds};
      let tempAttributes = {};
      if (onlyEditAttributeData && onlyEditAttributeData.length > 0) {
        onlyEditAttributeData.map((data) => {
          if (isArray(values[`${data.attributeId}.productAttribute`]) && values[`${data.attributeId}.productAttribute`].length || !isArray(values[`${data.attributeId}.productAttribute`]) && values[`${data.attributeId}.productAttribute`]) {
            tempAttributes[data.attributeId] = getCategoryAttributeValue(data.attributeId, values[`${data.attributeId}.productAttribute`], onlyEditAttributeData, infoData);
          }
        });
      }
      const result = {
        attributes: {productAttributes: tempAttributes},
        channelId: "TIKTOK_ID",
        productName: values.productName,
        externalFullCategoryId: values.categoryIds?.join("-"),
        certifications,
        brandId: values.brandId,
        currencyCode,
        warranty: {
          warrantyPolicy: values?.warrantyPolicy,
          warrantyId: values?.warrantyId
        },
        ...params
      };
      return result;
    }
  }));
  const shopSelectChange = (value) => {
    getCategoryRecommend();
    handleSetVariationOptions(defaultData);
    resetData();
    if (!value.length) {
      setShopCountry("");
      setShopId("");
      setSupportMultiWarehouse(void 0);
    }
    if (value && value[0]) {
      const selectedShop = shopsData.find((shop) => shop.id === value[0]);
      if (shopId !== selectedShop?.id) {
        form.setFieldsValue({
          categoryIds: "",
          brandId: ""
        });
      }
      checkShopStatus(selectedShop?.id || "");
      setCurrencyCode(selectedShop?.currencyCode);
      setShopCountry(selectedShop?.countryCode);
      setExternalShopId(selectedShop?.externalShopId);
      setShopId(selectedShop?.id);
      setSupportMultiWarehouse(selectedShop.multiWarehouse);
      fetchExternalWare({channel: "TIKTOK_ID", shopId: selectedShop?.id || ""});
    }
  };
  const tagRender = (props2) => {
    const {label, value, closable, onClose} = props2;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return /* @__PURE__ */ React.createElement(Tag, {
      color: value,
      onMouseDown: onPreventMouseDown,
      closable,
      onClose,
      style: {marginRight: 3, color: "#333"}
    }, /* @__PURE__ */ React.createElement(TableStoreLogo, {
      size: 16,
      channelName: "TikTok"
    }), label);
  };
  const dyItemsRender = (data, formatMessage2) => {
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
      span: "12"
    }, data.type === "TEXT" && /* @__PURE__ */ React.createElement(Form.Item, {
      name: `${data.attributeId}.productAttribute`,
      label: data.attributeName,
      rules: [{required: data.mandatory}]
    }, /* @__PURE__ */ React.createElement(Input, {
      placeholder: formatMessage2({
        id: "pleaseEnter"
      })
    })), data.type === "TEXT_QUANTITATIVE" && /* @__PURE__ */ React.createElement(Form.Item, {
      name: `${data.attributeId}.productAttribute`,
      label: data.attributeName,
      rules: [
        {
          required: data.mandatory,
          message: formatMessage2({id: "pleaseEnter"})
        }
      ]
    }, /* @__PURE__ */ React.createElement(TextQuantitative, {
      options: data?.attributeUnitList?.map((_) => {
        return {
          value: _,
          label: _
        };
      }),
      placeholder: formatMessage2({
        id: "pleaseEnter"
      })
    })), data.type === "SELECT" && /* @__PURE__ */ React.createElement(Form.Item, {
      name: `${data.attributeId}.productAttribute`,
      label: data.attributeName,
      rules: [
        {
          required: data.mandatory,
          message: formatMessage2({id: "pleaseSelect"})
        }
      ]
    }, /* @__PURE__ */ React.createElement(Select, {
      placeholder: formatMessage2({
        id: "pleaseSelect"
      }),
      showSearch: true,
      optionFilterProp: "title"
    }, data.options.map((_) => {
      return /* @__PURE__ */ React.createElement(Option, {
        value: _.attributeValueId,
        title: _.name
      }, _.name);
    }))), data.type === "SELECT_INPUT" && /* @__PURE__ */ React.createElement(Form.Item, {
      name: `${data.attributeId}.productAttribute`,
      label: data.attributeName,
      rules: [
        {
          required: data.mandatory,
          message: formatMessage2({id: "pleaseSelect"})
        }
      ]
    }, /* @__PURE__ */ React.createElement(SelectInput3, {
      options: data.options.map((_) => {
        return {
          label: _.name,
          value: _.attributeValueId
        };
      }),
      placeholder: formatMessage2({
        id: "pleaseSelect"
      }),
      addAttributeValueMsg: formatMessage2({
        id: "addAttributeValue"
      }),
      pleaseEnterMsg: formatMessage2({
        id: "pleaseEnter"
      })
    })), data.type === "SELECT_INPUT_QUANTITATIVE" && /* @__PURE__ */ React.createElement(Form.Item, {
      name: `${data.attributeId}.productAttribute`,
      label: data.attributeName,
      rules: [
        {
          required: data.mandatory,
          message: formatMessage2({id: "pleaseEnter"})
        }
      ]
    }, /* @__PURE__ */ React.createElement(SelectInputQuantitative, {
      unitOptions: data?.attributeUnitList?.map((_) => {
        return {
          label: _,
          value: _
        };
      }),
      options: data.options.map((_) => {
        return {
          label: _?.name,
          value: _?.attributeValueId
        };
      }),
      placeholder: formatMessage2({
        id: "pleaseSelect"
      }),
      addAttributeValueMsg: formatMessage2({
        id: "addAttributeValue"
      }),
      pleaseEnterMsg: formatMessage2({
        id: "pleaseEnter"
      })
    })), data.type === "MULTI_SELECT" && /* @__PURE__ */ React.createElement(Form.Item, {
      name: `${data.attributeId}.productAttribute`,
      label: data.attributeName,
      rules: [
        {
          required: data.mandatory,
          message: formatMessage2({id: "pleaseSelect"})
        },
        {
          type: "array",
          message: formatMessage2({
            id: "attributeTip"
          })
        }
      ]
    }, /* @__PURE__ */ React.createElement(Select, {
      mode: "multiple",
      placeholder: formatMessage2({
        id: "pleaseSelect"
      }),
      style: {width: "100%"},
      showSearch: true,
      optionFilterProp: "title"
    }, data.options.map((_) => {
      return /* @__PURE__ */ React.createElement(Option, {
        value: _.attributeValueId,
        title: _.name
      }, _.name);
    }))), data.type === "MULTI_SELECT_INPUT" && /* @__PURE__ */ React.createElement(Form.Item, {
      name: `${data.attributeId}.productAttribute`,
      label: data.attributeName,
      rules: [
        {
          required: data.mandatory,
          message: formatMessage2({id: "pleaseSelect"})
        },
        {
          type: "array",
          message: formatMessage2({
            id: "attributeTip"
          })
        }
      ]
    }, /* @__PURE__ */ React.createElement(SelectInput3, {
      mode: "multiple",
      options: data.options.map((_) => {
        return {
          label: _?.name,
          value: _?.attributeValueId
        };
      }),
      placeholder: formatMessage2({
        id: "pleaseSelect"
      }),
      addAttributeValueMsg: formatMessage2({
        id: "addAttributeValue"
      }),
      pleaseEnterMsg: formatMessage2({
        id: "pleaseEnter"
      })
    })), data.type === "DATE" && /* @__PURE__ */ React.createElement(Form.Item, {
      name: `${data.attributeId}.productAttribute`,
      label: data.attributeName,
      rules: [{required: data.mandatory}]
    }, /* @__PURE__ */ React.createElement(DatePicker, null)), ![
      "TEXT",
      "TEXT_QUANTITATIVE",
      "DATE",
      "SELECT",
      "SELECT_INPUT",
      "SELECT_INPUT_QUANTITATIVE",
      "MULTI_SELECT",
      "MULTI_SELECT_INPUT"
    ].includes(data.type) && /* @__PURE__ */ React.createElement("p", {
      style: {color: "red"}
    }, "\u6682\u4E0D\u652F\u6301", data.type, "\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u7C7B\u76EE")));
  };
  const handleSearchBrand = useCallback(debounce((val) => {
    fetchBrands({
      channel: "TIKTOK_ID",
      country: shopCountry,
      categoryId: "",
      prefix: val,
      shopId
    }, false);
  }, 500), [shopCountry, shopId]);
  const {loading: syncLoading, runAsync: syncBrandFn} = useRequest((params) => request.post("/infra/shop/sync/pull-data-from-channel", {
    syncDataType: "CHANNEL_BRAND",
    syncAction: params?.syncAction,
    genieShopId: params?.shopId || "",
    syncSource: "MANUALLY_FROM_ERP",
    dataIdList: params?.keywordList,
    dataSnList: params?.keywordList
  }), {
    manual: true
  });
  const handleSyncBrand = async () => {
    try {
      await syncBrandFn({
        keywordList: brandKeyword ? [brandKeyword] : [],
        syncAction: brandKeyword ? "SPECIFIC_ID" : "FULLY_SYNC",
        shopId
      });
      fetchBrands({
        channel: "TIKTOK_ID",
        country: shopCountry,
        prefix: "",
        categoryId: "",
        shopId
      }, true);
      message.success(formatMessage({id: "syncSuccessfully"}));
      setBrandKeyword("");
    } catch (error) {
      console.log("error", error);
      message.error(formatMessage({id: "syncFailed"}));
    }
  };
  const categoryBeforeResetInfo = (val) => {
    handleSetVariationOptions(defaultData);
    resetData();
    form.setFieldsValue({
      brandId: void 0
    });
    let param = {
      countryCode: shopCountry,
      channel: "TIKTOK_ID",
      categoryId: [...val].pop()
    };
    fetchCategoryAttributes(param);
    fetchCategoryRuleChannel(param);
    fetchBrands({
      channel: "TIKTOK_ID",
      country: shopCountry,
      prefix: "",
      categoryId: "",
      shopId
    }, false);
  };
  const handleCategoryChange = (val) => {
    handleSetVariationOptions(defaultData);
    resetData();
    form.setFieldsValue({
      brandId: void 0
    });
    setCatrgoryInfo(val && [...val]?.pop());
    if (!val || !val.length) {
      resetCategoryRuleChannel();
      return;
    }
    let param = {
      countryCode: shopCountry,
      channel: "TIKTOK_ID",
      categoryId: [...val].pop()
    };
    fetchCategoryAttributes(param);
    fetchCategoryRuleChannel(param);
    fetchBrands({
      channel: "TIKTOK_ID",
      country: shopCountry,
      prefix: "",
      categoryId: "",
      shopId
    }, false);
  };
  const tiktokProductCertificationsList = useMemo(() => {
    const {tiktokProductCertifications = []} = categoryRuleChannel;
    return tiktokProductCertifications;
  }, [categoryRuleChannel]);
  const renderCertification = useMemo(() => () => {
    if (!categoryRuleChannel || tiktokProductCertificationsList.length === 0)
      return null;
    const uploadList = /* @__PURE__ */ React.createElement(React.Fragment, null, tiktokProductCertificationsList.map((item) => {
      return /* @__PURE__ */ React.createElement(Col, {
        span: "24",
        key: item?.id
      }, /* @__PURE__ */ React.createElement(Form.Item, {
        name: ["certifications", item.id],
        rules: [
          {
            required: item?.isMandatory,
            message: formatMessage({id: "pleaseChoose"})
          }
        ]
      }, /* @__PURE__ */ React.createElement(UploadCertification, {
        modalWidth: 500,
        limitWH: [600, 600],
        otherData: {
          channel: "TIKTOK_ID",
          fileType: "CERTIFICATION_IMAGE",
          shopId
        },
        otherParams: item,
        limitNum: 3,
        onChange: (files) => {
          form.setFieldsValue({
            certifications: {
              [item.id]: files
            }
          });
        }
      })));
    }));
    return uploadList;
  }, [tiktokProductCertificationsList]);
  const renderViewMore = useCallback(() => {
    const content = /* @__PURE__ */ React.createElement("div", {
      className: "view-more-box",
      onClick: () => {
        setShowMore(!showMore);
      }
    }, /* @__PURE__ */ React.createElement("img", {
      style: {
        transform: showMore ? "rotate(180deg)" : ""
      },
      src: viewMoreSvg
    }), formatMessage({id: showMore ? "viewLess" : "viewMore"}));
    return content;
  }, [showMore]);
  return /* @__PURE__ */ React.createElement(Wrapper, {
    id: "basicInfo",
    className: "block-info"
  }, /* @__PURE__ */ React.createElement(Collapse, {
    defaultActiveKey: ["1"],
    expandIconPosition: "right",
    expandIcon: ({isActive}) => /* @__PURE__ */ React.createElement(IconDown, {
      style: {
        transition: "all, 0.3s",
        position: "absolute",
        top: 10,
        transform: `rotate(${isActive ? 0 : "-90deg"})`
      }
    })
  }, /* @__PURE__ */ React.createElement(Panel, {
    header: /* @__PURE__ */ React.createElement("div", {
      className: "block-title"
    }, formatMessage({id: "basicInformation"})),
    key: "1"
  }, /* @__PURE__ */ React.createElement(Spin, {
    spinning: categoryLoading
  }, /* @__PURE__ */ React.createElement(Form, {
    form,
    layout: "vertical"
  }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    shouldUpdate: (prevValues, currentValues) => prevValues.shopIds !== currentValues.shopIds,
    noStyle: true
  }, ({getFieldValue}) => {
    return /* @__PURE__ */ React.createElement(Form.Item, {
      label: formatMessage({id: "onSaleShop"}),
      name: "shopIds",
      rules: [
        {
          required: true,
          message: formatMessage({id: "pleaseChoose"})
        }
      ]
    }, /* @__PURE__ */ React.createElement(Select, {
      style: {width: "100%"},
      className: "shops-select",
      allowClear: true,
      mode: "multiple",
      getPopupContainer: (triggerNode) => triggerNode.parentNode,
      maxTagTextLength: 100,
      maxTagCount: 1,
      disabled: isEdit,
      tagRender,
      optionLabelProp: "title",
      optionFilterProp: "title",
      onChange: shopSelectChange,
      placeholder: formatMessage({
        id: "onSaleShop"
      })
    }, shopsData && shopsData.map((item) => /* @__PURE__ */ React.createElement(Option, {
      value: item.id,
      key: item.id,
      title: item.shopName,
      disabled: !!shopId && shopId !== item.id
    }, /* @__PURE__ */ React.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "nowrap"
      }
    }, /* @__PURE__ */ React.createElement("span", {
      role: "img",
      style: {marginRight: 4}
    }, /* @__PURE__ */ React.createElement("img", {
      src: getFieldValue("shopIds") && getFieldValue("shopIds").includes(item.id) ? checked : unchecked,
      className: "select-checkbox"
    })), /* @__PURE__ */ React.createElement(TableStore, {
      size: 16,
      channelName: item.channelName,
      shopName: item.shopName,
      countryCode: item.countryCode
    }))))));
  }))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    label: formatMessage({id: "productName"}),
    name: "productName",
    rules: [
      {
        required: true,
        message: formatMessage({id: "enterTheProductNamePlease"})
      },
      {
        min: PRODUCTNAME_MIN_NUMBER,
        max: PRODUCTNAME_MAX_NUMBER,
        message: formatMessage({id: "productNameMinMaxCharacters"}, {
          min: PRODUCTNAME_MIN_NUMBER,
          max: PRODUCTNAME_MAX_NUMBER
        })
      },
      {
        validator: (rules, value) => {
          const reg = new RegExp(/[\u4E00-\u9FA5]/g);
          if (reg.test(value)) {
            return Promise.reject();
          }
          return Promise.resolve();
        },
        message: formatMessage({id: "canNotInputChineseLanguage"})
      }
    ]
  }, /* @__PURE__ */ React.createElement(InputLimit, {
    maxLength: PRODUCTNAME_MAX_NUMBER,
    disabled: !shopCountry,
    limit: PRODUCTNAME_MAX_NUMBER,
    onBlur: () => {
      let productName = form.getFieldValue("productName")?.trim();
      form.setFieldsValue({
        productName
      });
      getCategoryRecommend();
    }
  })))), /* @__PURE__ */ React.createElement(Row, {
    style: {display: shopCountry ? "block" : "none"}
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    label: formatMessage({id: "category"}),
    required: true
  }, /* @__PURE__ */ React.createElement(RecommendedCheck, {
    categoryRecommend,
    onSelect: (ids) => {
      if (ids && ids.length > 0) {
        form.setFieldsValue({
          categoryIds: ids
        });
        categoryBeforeResetInfo(ids);
      }
    }
  }), /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    noStyle: true,
    name: "categoryIds",
    rules: [
      {
        required: true,
        message: formatMessage({id: "pleaseSelect"})
      }
    ]
  }, /* @__PURE__ */ React.createElement(CascaderWrapper, {
    id: "categoryIds",
    countryCode: shopCountry,
    onChange: handleCategoryChange
  }))))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    span: "12"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    shouldUpdate: true,
    noStyle: true
  }, () => {
    const categoryId = [...form.getFieldValue("categoryIds") || []].pop();
    return /* @__PURE__ */ React.createElement(Form.Item, {
      style: {display: categoryId ? "block" : "none"},
      label: /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement("div", {
        style: {display: "flex"}
      }, formatMessage({id: "brand"}), /* @__PURE__ */ React.createElement(SyncButton, {
        getSyncData: handleSyncBrand,
        style: {top: 0},
        isLoading: updateBrandsLoading
      })), /* @__PURE__ */ React.createElement(Popover, {
        content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(ExclamationCircleOutlined, {
          style: {marginTop: "4px", marginRight: "4px"}
        }), /* @__PURE__ */ React.createElement(Typography.Text, {
          style: {maxWidth: 300, color: "#666", marginBottom: "4px"}
        }, formatMessage({
          id: "dueToPossibleDelaysInSyncing"
        })))), /* @__PURE__ */ React.createElement(Space, null, /* @__PURE__ */ React.createElement(Input, {
          style: {width: 440},
          placeholder: formatMessage({id: "pleaseEnterBrandKeywordsToSync"}),
          value: brandKeyword,
          onChange: (e) => setBrandKeyword(e?.target?.value)
        }), /* @__PURE__ */ React.createElement(Button, {
          loading: syncLoading,
          type: "link",
          onClick: handleSyncBrand
        }, formatMessage({id: "sync"})))),
        trigger: "click"
      }, /* @__PURE__ */ React.createElement("div", {
        style: {wordBreak: "break-all", color: "#6020FF", cursor: "pointer"}
      }, formatMessage({
        id: "cantFindTheBrandClickMe"
      })))),
      name: "brandId",
      rules: [
        {
          required: ["PUBLISH"].includes(handleStatus) ? true : false,
          message: formatMessage({
            id: "pleaseSelect"
          })
        }
      ]
    }, /* @__PURE__ */ React.createElement(Select, {
      disabled: !categoryId,
      placeholder: formatMessage({id: "pleaseSelect"}),
      loading: brandsLoading,
      allowClear: true,
      filterOption: false,
      showSearch: true,
      onSearch: handleSearchBrand
    }, brands.map((_) => {
      if (_.label === "0") {
        return /* @__PURE__ */ React.createElement(Option, {
          key: "0",
          value: "0",
          title: formatMessage({id: "NoBrand"})
        }, formatMessage({id: "NoBrand"}));
      }
      return /* @__PURE__ */ React.createElement(Option, {
        key: _.label,
        value: _.label,
        title: _.value
      }, _.value);
    })));
  }))), /* @__PURE__ */ React.createElement("div", {
    style: {display: showMore ? "block" : "none"}
  }, tiktokProductCertificationsList && tiktokProductCertificationsList.length !== 0 && /* @__PURE__ */ React.createElement(Form.Item, {
    label: "Certiafication"
  }, /* @__PURE__ */ React.createElement(Row, {
    gutter: 24
  }, /* @__PURE__ */ React.createElement(Input.Group, null, renderCertification()))), onlyEditAttributeData.length ? onlyEditAttributeData.map((data, index) => dyItemsRender(data, formatMessage)) : ""), /* @__PURE__ */ React.createElement(React.Fragment, null, shopCountry && /* @__PURE__ */ React.createElement("div", null, renderViewMore())))))));
});
const Wrapper = styled.div`
  &.block-info {
    background: #ffffff;
  }

  .view-more-box {
    height: 33px;
    background: #f5f7fa;
    margin: 16px auto;
    font-size: 13px;
    color: #6020ff;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .suffix-append {
    position: absolute;
    display: inline-block;
    bottom: -15px;
    right: 5px;
    opacity: 0.5;
    z-index: 3;
    margin: 20px 0;
  }
  .block-title {
    font-size: 14px;
    font-family: SFProText-Medium, SFProText;
    font-weight: 500;
    color: #161344;
    line-height: 20px;
  }
  .block-input-group {
    display: flex;
    .ant-input-number {
      flex: 1;
    }
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
  .block-input-group-handler {
    .ant-input-number-handler-wrap {
      display: block;
      opacity: 1;
    }
  }
  .ant-collapse {
    border: 1px solid #dfe3e8;
    background: #fff;
    border-radius: 0;
  }
  .ant-collapse > .ant-collapse-item {
    border-bottom: 0;
  }
  .ant-collapse-content {
    border-top: 1px solid #dfe3e8;
    overflow: inherit;
  }
  .ant-input-textarea textarea {
    min-height: 118px;
  }
  .ant-input-textarea-show-count:after {
    margin-top: 8px;
    font-size: 10px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #7f8fa4;
    line-height: 12px;
  }
  .ant-form-item {
    margin-bottom: 16px;
  }
  .shops-select {
    .ant-select-selection__choice__content {
      .select-checkbox {
        display: none !important;
      }
    }
    .select-checkbox {
      width: 14px;
      height: 14px;
      position: relative;
      top: -1px;
    }
    .ant-select-selector {
      border-radius: 3px 0 0 3px !important;
    }
  }
  .ant-select-selection-overflow {
    position: relative;
    display: flex;
    flex: auto;
    flex-wrap: wrap;
    max-width: 100%;
  }
`;
export default BaseInfo;
